/* Scroll speed for the 2026 PDP's "as seen at" logo marquee.

   The motion is a CSS animation -- translateX(-50%) over a track that holds
   the logo list twice -- so all this does is decide how long one pass takes.

   Why not a fixed duration
   ------------------------
   A duration is a time, and what has to stay constant is a speed. The same
   26s would scroll faster with eight logos than with four, and faster again
   past 768px where the gap grows from 30px to 56px and the logos from 60px to
   90px. So measure the track and divide.

   SPEED started at the motion prototype's own rate -- its track is 1993px,
   half of it 997px, crossed in 26s, so 38.3px/s -- and was then eased back
   because that read as hurried against our logos, which are wider and fewer
   than the prototype's wordmarks. 30px/s is also exactly what the old
   frame-based scroller did on a 60Hz display, so it is the pace the live site
   has been showing all along. One number to change if it wants adjusting
   again.

   This also replaces the LogoScroller class in the shared main-*.js bundle,
   which moved the track 0.5px per animation frame -- 30px/s at 60Hz, 60px/s
   at 120Hz, so the speed depended on the shopper's screen. That class binds to
   .logo-scroller-wrapper; the 2026 markup no longer uses that name, so it
   leaves this marquee alone and the older templates keep it unchanged. */
(function () {
  if (window.EttikaLogoMarquee) return;

  var SPEED = 20; // px per second

  function size(track) {
    /* Half, because the track holds the list twice and the animation travels
       exactly one copy. Widths come from CSS, not from the files, so this is
       correct before the images have loaded. */
    var half = track.scrollWidth / 2;
    if (!half) return;
    track.style.setProperty('--marquee-duration', (half / SPEED).toFixed(2) + 's');
  }

  function scan() {
    var tracks = document.querySelectorAll('.pdp2026-logos__track');
    for (var i = 0; i < tracks.length; i++) size(tracks[i]);
  }

  function start() {
    scan();

    /* The gap and the logo size both change at 768px, so the track's width
       changes with the viewport and the duration has to follow it. */
    if (typeof ResizeObserver !== 'undefined') {
      var observer = new ResizeObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) size(entries[i].target);
      });
      var tracks = document.querySelectorAll('.pdp2026-logos__track');
      for (var j = 0; j < tracks.length; j++) observer.observe(tracks[j]);
    } else {
      window.addEventListener('resize', scan);
    }

    /* The block is re-rendered on a variant change and in the theme editor. */
    document.addEventListener('shopify:section:load', scan);
  }

  window.EttikaLogoMarquee = { scan: scan };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
